var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMargenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 2.78841C4.59833 3.16371 1.75 6.24926 1.75 10.0001C1.75 14.0042 4.99594 17.2501 9 17.2501C12.7508 17.2501 15.8364 14.4018 16.2117 10.7501H9C8.58579 10.7501 8.25 10.4143 8.25 10.0001V2.78841ZM0.25 10.0001C0.25 5.16759 4.16751 1.25009 9 1.25009C9.41421 1.25009 9.75 1.58587 9.75 2.00009V9.25009H17C17.4142 9.25009 17.75 9.58587 17.75 10.0001C17.75 14.8326 13.8325 18.7501 9 18.7501C4.16751 18.7501 0.25 14.8326 0.25 10.0001Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 1.67373V6.50009H17.3264C16.7633 4.11568 14.8844 2.23676 12.5 1.67373ZM11.998 0.0617319C15.6183 0.51226 18.4878 3.38176 18.9384 7.00207C19.0066 7.55013 18.5523 8.00009 18 8.00009H11.5C11.2239 8.00009 11 7.77623 11 7.50009V1.00009C11 0.447801 11.45 -0.00647078 11.998 0.0617319Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMargenIcon);
export default __webpack_public_path__ + "static/media/margenIcon.d4328f83628e8e2d8fee83e4a2d84b7e.svg";
export { ForwardRef as ReactComponent };